
import React from 'react';
import './modal.css';
import { color } from '@storybook/addon-knobs';

const Modal = ({ show, onClose, onConfirm, title, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="custom-modal-backdrop">
      <div className="custom-modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button type="button" className="close" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm} style={{"background-color":"#BB23F9"}}>
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
